// extracted by mini-css-extract-plugin
export default {"panel":"f_MjRFP1qeFh5SEjdJEj"};